import React from 'react';

const Blank = ({height}) => {
    return (
        <div style={{height:height, display:'block'}}>
            
        </div>
    );
};

export default Blank;